import {
  AI_RECEPTIONIST_FEATURE,
  AI_SCRIBE_FEATURE,
} from '@principle-theorem/principle-core/features';
import { type IAiSuiteFeature } from './ai-suite-feature';

/**
 * Append entries here to add new AI feature dashboards.
 * The shell, routing module, and nav absorb new entries automatically.
 */
export const AI_SUITE_FEATURES: readonly IAiSuiteFeature[] = [
  {
    id: 'ai-receptionist',
    label: 'AI Receptionist',
    description:
      'AI Receptionist — calls, bookings, after-hours coverage and ROI.',
    icon: 'support_agent',
    feature: AI_RECEPTIONIST_FEATURE,
    loadComponent: () =>
      import(
        './features/ai-receptionist/ai-receptionist-dashboard.component'
      ).then((module) => module.AiReceptionistDashboardComponent),
  },
  {
    id: 'ai-scribe',
    label: 'AI Scribe',
    description:
      'AI Scribe — voice-to-notes capture, sessions, seats and test tools.',
    icon: 'graphic_eq',
    feature: AI_SCRIBE_FEATURE,
    loadComponent: () =>
      import('./features/ai-scribe/ai-scribe-dashboard.component').then(
        (module) => module.AiScribeDashboardComponent
      ),
  },
];
